<template>
  <div>
    <ConfigListItem
      label="RPM"
      :value="strValue"
      :date="maxUpdatedAt"
      :login="maxUpdatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :max-width="800">
      <v-card>
        <ODialogBar title="Origem da RPM" @close="dismiss" />
        <v-card-text v-if="readonly" class="pa-6">
          <p>
            O valor da configuração "Uso da Serial" está 0x03 ou 0x04, o que
            impede a alteração desta configuração.
          </p>
          <p>
            Entre em contato com o time de desenvolvimento para corrigir.
          </p>
        </v-card-text>
        <v-card-text v-else class="pa-6">
          <div class="d-flex">
            <OVerticalTabs
              class="mr-6"
              v-model="clonedValues.rpmSource"
              :tabs="[
                { value: 'sensor', text: 'Sensor' },
                { value: 'accel', text: 'Acelerômetro' },
                { value: 'voltage', text: 'Voltagem' },
                { value: 'can', text: 'CAN' }
              ]"
            />

            <v-tabs-items class="flex-grow-1" v-model="clonedValues.rpmSource">
              <div class="px-4" v-if="clonedValues.rpmSource == null">
                Escolha um valor da lista ao lado.
              </div>

              <v-tab-item value="sensor" class="px-4 pb-1">
                <OTextField
                  v-model.number="clonedValues.rpmConstant"
                  label="Valor da constante"
                />
                <OSelect
                  label="RPM por Freq?"
                  v-model="clonedValues['rpm-por-freq']"
                  :items="rpmPorFreqOpts"
                  item-text="label"
                />
              </v-tab-item>

              <v-tab-item value="accel" class="px-4 pb-1">
                <OTextField
                  label="Limiar a partir do qual o RPM ficará em 100 (0 para desativar)"
                  v-model.number="clonedValues['rpm-por-acel']"
                />
                <OTextField
                  label="Segundos necessários para que o acel abra trecho"
                  v-model.number="clonedValues['acel-rpm-delay']"
                />
              </v-tab-item>

              <v-tab-item value="voltage" class="px-4 pb-1">
                <OTextField
                  label="Limiar de voltagem acima do qual o RPM ficará em 250"
                  v-model.number="clonedValues['rpm-por-voltagem']"
                />
              </v-tab-item>

              <v-tab-item value="can" class="px-4">
                <SelectCANVariable
                  :canDictId="canDictId"
                  v-model="clonedValues.rpmCanVariable"
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-card-text>
        <ODialogButtons
          v-if="!readonly"
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import ConfigListItem from './ConfigListItem.vue'
import VehicleCfgs from 'vehicle-cfgs'
import {
  mostRecentlyUpdated,
  decHex,
  getCfg,
  getManyCfgs
} from './config-utils.js'
import SelectCANVariable from './SelectCANVariable.vue'
import OVerticalTabs from './OVerticalTabs.vue'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs) {
  let cfgs = getManyCfgs(
    allConfigs,
    'canDict',
    'rpmSource',
    'rpmConstant',
    'rpm-por-freq',
    'rpm-por-acel',
    'acel-rpm-delay',
    'rpm-por-voltagem',
    'rpmCanVariable'
  )

  switch (cfgs.rpmSource) {
    case 'sensor': {
      // nb: decidimos não mostrar o rpmPorFreq
      let x = cfgs.rpmConstant
      return `Sensor rpmConstant=${decHex(x)}`
    }
    case 'accel': {
      let x = cfgs['rpm-por-acel']
      let y = cfgs['acel-rpm-delay']
      return `Acelerômetro limiar=${x} seg=${y}`
    }
    case 'voltage': {
      let x = cfgs['rpm-por-voltagem']
      return `Voltagem limiar=${x}`
    }
    case 'can': {
      let y = cfgs.rpmCanVariable
      return `CAN variable=${y && y.code}`
    }
    default:
      return '???'
  }
}

export function copyValue(allConfigs) {
  return getManyCfgs(
    allConfigs,
    'rpmSource',
    'rpmConstant',
    'rpm-por-freq',
    'rpm-por-acel',
    'acel-rpm-delay',
    'rpm-por-voltagem',
    'rpmCanVariable'
  )
}

export default {
  components: { ConfigListItem, SelectCANVariable, OVerticalTabs },
  props: {
    allConfigs: { required: true }
  },
  data() {
    return {
      rpmPorFreqOpts: VehicleCfgs.get('rpm-por-freq', 'opts'),
      clonedValues: { rpmSource: 'sensor' }
    }
  },
  computed: {
    readonly() {
      let x = getCfg(this.allConfigs, 'uso-da-serial')
      return x == '0x03' || x == '0x04'
    },
    canDictId() {
      return getCfg(this.allConfigs, 'canDictId')
    },
    strValue() {
      return displayValue(this.allConfigs)
    },
    mostRecent() {
      return mostRecentlyUpdated(
        this.allConfigs,
        'rpmSource',
        'rpmConstant',
        'rpm-por-freq',
        'rpm-por-acel',
        'acel-rpm-delay',
        'rpm-por-voltagem',
        'rpmCanVariable'
      )
    },
    maxUpdatedAt() {
      return this.mostRecent && this.mostRecent.updatedAt
    },
    maxUpdatedBy() {
      return this.mostRecent && this.mostRecent.updatedBy
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValues = getManyCfgs(
        this.allConfigs,
        'rpmSource',
        'rpmConstant',
        'rpm-por-freq',
        'rpm-por-acel',
        'acel-rpm-delay',
        'rpm-por-voltagem',
        'rpmCanVariable'
      )
      return this.$refs.dialog.$open()
    },
    async save() {
      const payload = this.clonedValues
      this.$emit('save', payload)
      this.dismiss()
    }
  }
}
</script>

<style></style>
